<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Fee Details Report
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="current_academic_year" :items="academic_year_list" item-text="ay" return-object label="Academic Year" outlined @change="clearselection()"
                    persistent-hint hint="Please Select Academic Year"
                    ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="section" :items="section_list" item-text="name" item-value="id" label="Section" outlined @change="clearselection();getStandard();"
                    persistent-hint hint="Please Select Section"
                    
                    ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="header" :items="header_list" item-text="category" item-value="id" label="Fee Header" outlined @change="clearselection();"
                    persistent-hint hint="Please Select Fee Header"
                    
                    ></v-autocomplete>
                </v-col>
                 <v-col sm="2" v-if="standard_list!=''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="std" multiple :items="standard_list" item-text="standard" item-value="id" label="Standard" outlined @change="clearselection()"
                    persistent-hint hint="Please Select  Standard"
                    ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <!-- <v-btn rounded class="button mt-6" @click="getDivison();getSubHeader()">Proceed</v-btn> -->
                    <v-btn rounded class="button mt-6" @click="getSubHeader()">Proceed</v-btn>
                </v-col>
            </v-row>
            <v-row justify="center" dense v-if="show">
                <v-col sm="2">
                     <v-icon color="error">*</v-icon>
                    <v-autocomplete multiple rounded dense required v-model="sub_header" :items="sub_header_data" item-text="name" item-value="id" label="Fee Sub Header" outlined @change="clear();"
                    persistent-hint hint="Please Select Fee Sub Header"
                    ></v-autocomplete>
                </v-col>
                <!-- <v-col sm="2" v-if="dision_list!=''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required multiple v-model="div" :items="dision_list" item-text="div_name" item-value="div_off_id" label="Division" outlined
                    persistent-hint hint="Please Select Division"
                    ></v-autocomplete>
                </v-col> -->
                <v-col sm="2">
                    <v-btn rounded class="button mt-6" @click="getAllReport();" :loading="loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12" v-if="learner_info!=''" class="">
                 <v-col sm="2">
                    <v-btn rounded  color="success" outlined @click="fnExcelReport('my-table-id','feedetailedreport');" :loading="loader"><v-icon   color="success">mdi-export</v-icon>Export</v-btn>
                </v-col>
                <div id="my-table-id">
                <div class="scroll">
                    <v-simple-table  dense class="elevation-1" fixed-header height="500px">
                        <thead>
                            <tr>
                                <th class="">Sr. No.</th>
                                <th class="">Registration No.</th>
                                <th class="">Name</th>
                                <th class="">Mobile No.</th>
                                <th class="">Quota</th>
                                <th class="">Academic Year</th>
                                <th class="">Standard</th>
                                <th class="">Division</th>
                                <th class="">Admission Year</th>
                                <th class="" colspan="3" v-for="(header,index) in component_headers" :key="index">
                                    <center>{{ header }}</center>
                                </th>
                            </tr>
                        </thead>
                        <tbody style="overflow-y: scroll;">
                            <tr>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th v-for="(header,index) in component_headers.length * 3" :key="index">
                                    <span v-if="header%3 == 0">
                                        Total
                                    </span>
                                    <span v-else-if="header%3 == 1">
                                        Paid
                                    </span>
                                     <span v-else>
                                        Balance
                                    </span>
                                </th>
                            </tr>
                            <tr v-for="s in learner_info" :key="s.id">
                                <td>{{s.sr_no}}</td>
                                <td>{{s.reg_no}}</td>
                                <td>{{s.name}}</td>
                                <td>{{s.mobile_no}}</td>
                                <td>{{s.quota}}</td>
                                <td>{{s.academicyear}}</td>
                                <td>{{s.standard}}</td>
                                <td>{{s.div}}</td>
                                <td>{{s.learner_addmission_year}}</td>
                                <td v-for="(header,index) in s.comp_amt" :key="index">
                                  <span v-if="header == 'Not Applicable'" class="text-color">
                                        {{header}}
                                    </span>
                                    <span v-else>
                                         {{header}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
                <v-row dense justify="center" v-if="data_list!=''">
                    <!--<table id="admitted-student" dense class="elevation-1 mytable"> -->
                    <v-simple-table  dense class="elevation-1" fixed-header height="500px">
                        <thead>
                            <tr>
                                <th class="">Sr. No.</th>
                                <th class="">Header</th>
                                <th class="">Total amount to be collected</th>
                                <th class="">Total amount collected</th>
                                <th class="">Total amount pending</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(l,index) in data_list" :key="l.id">
                                <td>{{index + 1}}</td>
                                <td>{{l.feescomponentacademicyear}}</td>
                                <td>{{l.amount}}</td>
                                <td>{{l.paid_till_now}}</td>
                                <td>{{l.remaining}}</td>
                            </tr>
                            <tr>
                                <td colspan="2">Overall Total</td>
                                <td>{{all_total_amount}}</td>
                                <td>{{all_total_paid}}</td>
                                <td>{{all_total_remaining}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-row>
                </div>
            </v-col>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                loader: false,
                color: "",
                snackbar: false,
                search: null,
                snackbar_msg: null,
                fees_structure_data: null,
                current_academic_year: null,
                stream: null,
                div: [],
                std: [],
                header: null,
                academic_year_list: null,
                standard_list: null,
                dision_list: [],
                stream_list: null,
                header_list: null,
                show: false,
                learner_info: [],
                data_list: [],
                component_headers: [],
                all_total_amount:null,
                all_total_paid:null,
                all_total_remaining:null,
                sub_header_data:[],
                sub_header:[],
                section_list:[],
                section:"",
            };
        },
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';
                tab_text = tab_text + '<x:Name>Test Sheet</x:Name>';
                tab_text = tab_text + '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>';
                tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $('#' + id).clone();
                exportTable.find('input').each(function (index, elem) { $(elem).remove(); });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + '</table></body></html>';
                var fileName = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

                //Save the file
                // var blob = new Blob([tab_text], { type: "application/vnd.ms-excel;charset=utf-8" })
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
                },
            ExportToExcel(){
            var htmltable= document.getElementById('my-table-id');
            var html = htmltable.outerHTML;
            window.open('data:application/vnd.ms-excel,' + encodeURIComponent(html));
            },
            clear() {
                this.learner_info = [];
                this.data_list = [];
            },
            clearselection() {
                (this.show = false), (this.learner_info = []);
                this.data_list = [];
                (this.div = []), (this.dision_list = []);
               // this.standard_list = null,
               // this.std = []
                
            },
            getAllReport() {
                this.learner_info= [],
                this.data_list= [],
                this.component_headers= [],
                this.all_total_amount=null,
                this.all_total_paid=null,
                this.all_total_remaining=null,
                this.loader = true;
                const data = {
                    ay: this.current_academic_year.id,
                    std: this.std,
                    section: this.section,
                  //  div: this.div,
                    header: this.header,
                    sub_header: this.sub_header,
                };
                axios
                    .post("/InstallmentStructureDetails/getAllReportZeal", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.loader = false;
                            this.learner_info = res.data.learner_info;
                            this.data_list = res.data.data_list;
                            this.component_headers = res.data.component_headers;
                            this.all_total_amount= res.data.all_total_amount;
                            this.all_total_paid= res.data.all_total_paid;
                            this.all_total_remaining= res.data.all_total_remaining;
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.loader = false;
                        // this.dataTable = $("#admitted-student-report").DataTable({
                        //     colReorder: true,
                        //     dom: "Bfrtip",
                        //     buttons: ["csvHtml5", "excelHtml5"],
                        // });
                        // this.dataTable = $("#admitted-student").DataTable({
                        //     colReorder: true,
                        //     dom: "Bfrtip",
                        //     buttons: ["csvHtml5", "excelHtml5"],
                        // });
                    });
            },
            getStandard(){
                this.standard_list = null,
                this.std = []
                const data = {
                    ay: this.current_academic_year.id,
                    section: this.section,
                };
                axios
                    .post("/InstallmentStructureDetails/getSectionStandrd", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.standard_list = res.data.standard_list;
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            getDivison() {
                const data = {
                    ay: this.current_academic_year.id,
                    std: this.std,
                };
                axios
                    .post("/InstallmentStructureDetails/getDivison", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.dision_list = res.data.dision_list;
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getSubHeader(){
                const data = {
                    ay: this.current_academic_year.id,
                    header: this.header,
                }
                axios
                .post("/InstallmentStructureDetails/getSubHeader", data)
                    .then((res) => {
                        this.show = true
                       this.sub_header_data = res.data.sub_header_data
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            onload() {
                axios
                    .post("/InstallmentStructureDetails/getAllData")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.academic_year_list = res.data.ay_data;
                            this.current_academic_year = res.data.cay;
                            this.stream_list = res.data.stream_list;
                            this.section_list = res.data.user_wise_section_list;
                            this.header_list = res.data.header_list;

                            // this.dision_list = [{ div_name: "All", id: null }];
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.get_ay_std_ft_loader = false;
                    });
            },
        },
        mounted() {
            this.onload();
            $.fn.DataTable = $.fn.dataTable;
        },
    };
</script>
<style scoped>
    .scroll {
        overflow-x: scroll;
    }
    .text-color {
        font-weight: bold;
        color: red;
        font-size: small;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .dt-button {
        font-size: small;
        font-weight: bold;
    }
    .dt-button.buttons-print::before {
        content: "\F42A";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    .dt-button.buttons-excel::before {
        content: "\F21B";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    .dt-button.buttons-csv::before {
        content: "\FEC2";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    button.dt-button:hover:not(.disabled),
    div.dt-button:hover:not(.disabled),
    a.dt-button:hover:not(.disabled) {
        border-color: #ff9800;
        color: #ff9800;
    }
    .dataTables_wrapper .dataTables_filter input[type="search"] {
        border-radius: 2px;
        border: 1px solid #cdcdcd;
        cursor: auto;
        white-space: nowrap !important;
    }
</style>
